import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { Home } from './pages/Home';
import { Family } from './pages/Family';
import { Menu } from './pages/Menu';
export function App() {
  return <BrowserRouter data-id="element-0">
      <div className="min-h-screen flex flex-col w-full bg-cream selection:bg-warm-brown selection:text-white" data-id="element-1">
        {/* Desktop Left Brick Edge - Mimicking the building facade */}
        <div className="hidden lg:block fixed left-0 top-0 bottom-0 w-12 xl:w-16 brick-pattern z-50 shadow-[4px_0_15px_rgba(0,0,0,0.4)] border-r border-dark-brick" data-id="element-2"></div>

        {/* Main Content Wrapper - Offset for the left brick edge on desktop */}
        <div className="flex-1 lg:ml-12 xl:ml-16 relative" data-id="element-3">
          <Header data-id="element-4" />

          <main data-id="element-5">
            <Routes data-id="element-6">
              <Route path="/" element={<Home data-id="element-8" />} data-id="element-7" />
              <Route path="/family" element={<Family data-id="element-10" />} data-id="element-9" />
              <Route path="/menu" element={<Menu data-id="element-12" />} data-id="element-11" />
            </Routes>
          </main>

          <Footer data-id="element-13" />
        </div>
      </div>
    </BrowserRouter>;
}